 <template>
  <v-form ref="paymentDeliveryEditForm" v-model="valid" class="paymentDelivery-page">
    <v-row>
      <v-col cols="12">
        <h1>Оплата и доставка</h1>
      </v-col>

      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-img :src="previewImage(true, headerImage)" width="246" height="195" class="mb-8">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
        <v-file-input label="Картинка"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="1768х1402"
                      append-icon="mdi-attachment"
                      v-model="headerImage">
        </v-file-input>
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                            v-model="paymentDelivery.title"
                            label="Заголовок"
                            outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="paymentDelivery.description"
                        label="Описание"
                        outlined
                    ></v-textarea>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="paymentDelivery.url_block" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                    <v-text-field
                            v-model="paymentDelivery.button_text"
                            label="Текст кнопки"
                            outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                            v-model="paymentDelivery.title_ua"
                            label="Заголовок"
                            outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="paymentDelivery.description_ua"
                        label="Описание"
                        outlined
                    ></v-textarea>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="paymentDelivery.url_block_ua" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                    <v-text-field
                            v-model="paymentDelivery.button_text_ua"
                            label="Текст кнопки"
                            outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
        <v-text-field
                v-model="paymentDelivery.button_url"
                label="Ссылка"
                outlined
        ></v-text-field>
        <v-btn @click="update">Сохранить</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import PageService from './../../api/PageService'
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'PaymentDelivery',
    props: {
    },
    components: {Editor},
    data: () => ({
      plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
      toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      headerImage: null,
      paymentDelivery: {
          image: null,
          image_url: null
      },
      loading: true,
      loadingButton: false,
    }),
    mounted() {
            PageService.getPaymentDelivery()
                .then(response => {
                    this.paymentDelivery = response.data;
                    if (this.paymentDelivery.image) {
                        this.headerImage = {}
                        this.headerImage.url = this.paymentDelivery.image_url;
                        this.headerImage.name = this.paymentDelivery.image
                    }
                    this.loading = false
                });
    },
    methods: {
      validate() {


      },
        previewImage(isHeader, image) {
            if (isHeader) {
                if (this.headerImage && this.headerImage.url) {
                    return this.headerImage.url
                }
            } else {
                if (this.footerImage && this.footerImage.url) {
                    return this.footerImage.url
                }
            }

            if (image) {
                return URL.createObjectURL(image)
            }
        },
      update(){

        this.loadingButton = true;
        let formData = this.getData();

        PageService.updatePaymentDelivery(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Страница успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении страницы';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('title', this.paymentDelivery.title);
          formData.append('title_ua', this.paymentDelivery.title_ua);
          formData.append('description', this.paymentDelivery.description);
          formData.append('description_ua', this.paymentDelivery.description_ua);
          formData.append('button_text', this.paymentDelivery.button_text);
          formData.append('button_text_ua', this.paymentDelivery.button_text_ua);
          formData.append('button_url', this.paymentDelivery.button_url);
          formData.append('url_block', this.paymentDelivery.url_block);
          formData.append('url_block_ua', this.paymentDelivery.url_block_ua);

          if (this.headerImage && !this.headerImage.url) {
              formData.append('headerImage', this.headerImage);
          }

          return formData;
      }
    },
  }
</script>

<style lang="scss">
  .paymentDelivery-page{
    .v-input__append-inner{
      margin-top: 13px!important;
    }
  }
</style>

<style scoped lang="scss">
  .paymentDelivery-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .paymentDelivery{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
